/* eslint-disable react-hooks/exhaustive-deps */
// import TicketMenuManagementCreate from "./lib/create";
import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { useTypedSelector } from 'common/hooks/useTypedSelector';
import ReservationDetailInfo from './lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';

import PrimaryButton from 'components/form/buttons/primaryButton';
import QuestionModal from 'components/modal/question';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function ReservationDetailPage() {
  const navigate = useNavigate();
  const params = useParams();

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);

  const { reservationDetail, reservationCancel, reservationUpdateTime, reservationConfirm }: any = useTypedSelector(
    (state) => state.Reservation
  );
  const { reservationDetailRequestAction, reservationConfirmRequestAction } = useActions();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    reservationDetailRequestAction(params?.id);
  };

  const handleShowConfirmModal = () => {
    setShowConfirmModal(true);
  };

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const handleConfirmReservation = () => {
    reservationConfirmRequestAction(reservationDetail?.data?.id, () => {
      handleCloseConfirmModal();
      navigate('/panel/reservation');
    });
  };

  const data: any = reservationDetail?.data;

  /*
   * The head row is gone. It used to float the status and the confirmation
   * above the card, unanchored, where two pale labels sitting alone on the
   * canvas read as controls rather than as state. Both are now chips inline
   * with the title in the card's section head, which is where the design puts
   * them and where the ticket and order screens already put theirs.
   *
   * Confirming is the one thing that was genuinely an action, so it stays a
   * button — and only in the state that can be acted on.
   */
  const canConfirm = data?.status === 'active' && !data?.confirmed;

  return (
    <S.Container>
      <PageTitle title={data?.subject || 'Reservation'} />

      {canConfirm ? (
        <S.Confirm>
          <PrimaryButton onClick={handleShowConfirmModal} className="sm">
            Confirm reservation
          </PrimaryButton>
        </S.Confirm>
      ) : (
        <></>
      )}

      <ReservationDetailInfo data={reservationDetail.data} fetchData={() => fetchData()} />

      <QuestionModal
        show={showConfirmModal}
        handleClose={handleCloseConfirmModal}
        model="success"
        title="Confirm Reservation"
        text="Do you want to Confirm this Reservation?"
        handleSuccess={handleConfirmReservation}
        successButtonText="Confirm"
      />

      <AppLoading
        loading={
          reservationDetail.loading ||
          reservationCancel.loading ||
          reservationUpdateTime.loading ||
          reservationConfirm.loading
        }
      />
    </S.Container>
  );
}
